import { ref } from 'vue';
import {
  getAppList,
} from '@/api/manage-app/app-manage';
import {
  IAppManageInfoListReq,
  IAppManageInfoItem,
} from '@/api/manage-app/app-manage/index.d';

export const useAppList = ({ type = '', accountId = '' } = {}) => {
  const appList = ref<IAppManageInfoItem[]>([]);

  const getAppListFn = async (params: IAppManageInfoListReq = {}) => {
    const { data } = await getAppList({
      type,
      accountId,
      ...params,
    });
    appList.value = data;
  };

  getAppListFn();

  return {
    appList,
    getAppListFn,
  };
};
